<div class="search-container">
  <nz-input-group
    class="w-1/2 pb-5"
    nzSearch
    nzSize="large"
    [nzAddOnAfter]="suffixIconButton"
  >
    <input
      #searchInput
      [(ngModel)]="searchValue"
      type="text"
      nz-input
      placeholder="Suchen Sie hier nach Spindbezeichnungen"
      (keydown.enter)="onSearch()"
    />
  </nz-input-group>
  <ng-template #suffixIconButton>
    <button (click)="onSearch()" nz-button nzType="primary" nzSearch>
      <span nz-icon nzType="search"></span>
    </button>
  </ng-template>
</div>

<nz-table
  *ngIf="!loading"
  #filterTable
  [nzData]="displayedLockers"
  nzSize="middle"
  nzTableLayout="auto"
  [nzFrontPagination]="true"
  [nzPageIndex]="1"
  [nzPageSize]="50"
  (nzQueryParams)="onTableQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th
        *ngFor="let column of listOfColumns"
        [nzSortOrder]="column.sortOrder"
        [nzSortFn]="column.sortFn"
        [nzFilters]="column.listOfFilter"
        [nzFilterFn]="column.filterFn"
        [nzShowFilter]="!!column.filterFn"
      >
        {{ column.name }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let data of filterTable.data"
      (click)="onLockerClick(data)"
      class="clickable-row"
    >
      <td>{{ data.bezeichnung }}</td>
      <td>{{ data.spindart }}</td>
      <td>{{ data.geschlecht }}</td>
      <td>{{ getStatus(data) }}</td>
      <td>{{ data.standort }}</td>
      <td>{{ geFormattedDate(data) }}</td>
    </tr>
  </tbody>
</nz-table>

<nz-spin
  *ngIf="loading"
  nzSize="large"
  nzTip="Lade Spinde..."
  style="padding-top: 50%"
>
</nz-spin>
